<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">จัดโปรโมชั่นราคาใหม่</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>


      <v-card>
        <v-form ref="form" @submit.prevent="editPromotionNew()">
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="d-flex">
                  <div class="title_form_main">
                    <div class="logo_timeline">
                      <img src="@/assets/arin_assets/tag.png">
                    </div>
                  </div>
                  <div class="header-content py-1 pl-5 pr-5 text-center">
                    <div class="content-font">ข้อมูลโปรโมชั่น</div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <v-form-group>
                  <label class="label_form_text">ชื่อโปรโมชั่น <span class="required--text">*</span></label>
                  <v-text-field color="#D6BFAF" v-model="promo.promotion_title" class="input-radius" prepend-inner-icon="mdi-card-account-details"
                    hide-details="auto" :rules="[v => (v[0] !== ' ' || 'กรุณาอย่าป้อนค่าว่างตัวแรก'), v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" :maxlength="255"
                    placeholder="กรุณากรอกชื่อโปรโมชั่น" single-line outlined dense required></v-text-field>
                </v-form-group>
              </v-col>
              <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <v-form-group>
                  <label class="label_form_text">ราคาโปรโมชั่น <span class="required--text">*</span></label>
                  <v-text-field color="#D6BFAF"  v-model="promo.promotion_price" class="input-radius" prepend-inner-icon="mdi-database-plus"
                    hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคาโปรโมชั่น']" :maxlength="7"
                    @keypress="isNumber($event, promo.promotion_price)" @paste="isPaste($event)"
                    placeholder="กรุณากรอกราคาโปรโมชั่น" single-line outlined dense required></v-text-field>
                </v-form-group>
              </v-col>
              <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                <v-form-group>
                  <label class="label_form_text">วันที่เริ่มต้นโปรโมชั่น <span class="required--text">*</span></label>
                  <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable color="#D6BFAF" class="input-radius" v-model="promo.date_start"
                        placeholder="กรุณาเลือกวันที่เริ่มต้นโปรโมชั่น"
                        :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่มต้นโปรโมชั่น']" prepend-inner-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" single-line outlined dense required></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#D6BFAF" v-model="promo.date_start" :min="promo.date_now"  @input="menu_start_date = false" no-title
                    scrollable></v-date-picker>
                  </v-menu>
                </v-form-group>
              </v-col>
              <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                <label class="label_form_text">วันที่สิ้นสุดโปรโมชั่น <span class="required--text">*</span></label>
                <v-menu ref="menu_stop_date" v-model="menu_stop_date" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field clearable color="#D6BFAF" class="input-radius" v-model="promo.date_stop"
                      placeholder="กรุณาเลือกวันที่สิ้นสุดโปรโมชั่น"
                      :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" single-line outlined dense required></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#D6BFAF" v-model="promo.date_stop" :min="promo.date_start" @input="menu_stop_date = false" no-title scrollable
                    single-line outlined dense required></v-date-picker>
                </v-menu>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                <v-form-group>
                  <label class="label_form_text">จำนวนสินค้าที่ต้องซื้อ <span class="required--text">*</span></label>
                  <v-text-field color="#D6BFAF" v-model="promo.promotion_buy" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto"
                    placeholder="กรุณากรอกจำนวนสินค้าที่ต้องซื้อ" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้าที่ต้องซื้อ']" :maxlength="7"
                    @keypress="isNumber($event, promo.promotion_buy)" @paste="isPaste($event)" single-line outlined
                    dense required></v-text-field>
                </v-form-group>
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <v-form-group>
                  <label class="label_form_text">รายละเอียด</label>
                  <v-textarea color="#D6BFAF" v-model="promo.promotion_detail" class="input-radius" hide-details="auto" placeholder="กรุณากรอกรายละเอียด" :maxlength="1500"
                    single-line outlined dense></v-textarea>
                </v-form-group>
              </v-col>

            </v-row>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="d-flex">
                  <div class="title_form_main">
                    <div class="logo_timeline">
                      <img src="@/assets/arin_assets/cycle.png">
                    </div>
                  </div>
                  <div class="header-content py-1 pl-5 pr-5 text-center">
                    <div class="content-font">สินค้าที่เข้าร่วมโปรโมชั่น</div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="9" xl="9" cols="12">
                <v-form-group>
                  <label class="label_form_text">เลือกสินค้าที่เข้าร่วมโปรโมชั่น <span
                      class="required--text">*</span></label>
                  <v-autocomplete color="#D6BFAF" :items="product_list" item-text="name" item-value="id" v-model="product_id" @change="getUnit"
                    class="input-radius" hide-details="auto" required placeholder="กรุณาเลือกสินค้าที่เข้าร่วมโปรโมชั่น" :rules="[data_list.length > 0 || 'กรุณาเลือกสินค้าที่เข้าร่วมโปรโมชั่น']"
                    single-line outlined dense></v-autocomplete>
                </v-form-group>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="3" xl="3" cols="12">
                <v-form-group>
                  <label class="label_form_text">หน่วยนับ <span class="required--text">*</span></label>
                  <v-autocomplete color="#D6BFAF" :items="product_unit_list" item-text="name" item-value="id" v-model="product_unit_id" @change="selectProduct"
                    class="input-radius" hide-details="auto" required placeholder="กรุณาเลือกหน่วยนับ" single-line :rules="[data_list.length > 0 || 'กรุณาเลือกหน่วยนับ']"
                    outlined dense></v-autocomplete>
                </v-form-group>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td class="hidden_line">
                        <div>{{ dataDetail.item.product_name }}</div>
                      </td>
                      <td class="hidden_line">
                        <div>{{ dataDetail.item.unit_name }}</div>
                      </td>
                      <td class="hidden_line">
                        <div>{{ dataDetail.item.price_standard }}</div>
                      </td>
                      <td class="pa-2 hidden_line">
                        <v-btn elevation="3" class="ma-2" outlined small height="45" color="#F28080" @click="deleteDataList(dataDetail.item.id)"
                          style="border-radius: 10px;background-color: #FFFFFF" title="ลบข้อมูล">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="title_page ma-3" style="justify-content:center;">
                  <v-btn type="submit" class="btn_add_data_sutmit" elevation="4" large>บันทึก</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { isTelephone, taxNumber, validateEmail, onPaste } from "@/js/handler";
import { minDate } from "@/js/handler";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_add_promotion_new",
  data() {
    return {
      loading_page: true,
      menu_start_date: false,
      menu_stop_date: false,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      product_id: '',
      product_list: [],
      product_unit_id: '',
      product_unit_list: [],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'จัดโปรโมชั่นสินค้า , บริการ',
          disabled: false,
        },
        {
          text: 'จัดโปรโมชั่นราคาใหม่',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ราคา',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ลบ',
          value: '',
          fixed: true,
          width: '150px',
          sortable: false,
          align: 'left',
        },
      ],
      promo: {
        promotion_title: '',
        promotion_price: '',
        date_start: '',
        date_stop: '',
        date_now: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        promotion_buy: '',
        promotion_detail: '',
        promotion_type: 1,
      },
      data_id: 1,
      data_list: [],
      data_edit_list: [],
    }
  },
  methods: {
    min_date: function () {
      return minDate()
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    async promotionNewDetail(){
      this.promo = {
        promotion_title: '',
        promotion_price: '',
        date_start: '',
        promotion_code: '',
        date_stop: '',
        date_now: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        promotion_buy: '',
        promotion_detail: '',
        promotion_type: 1,
      }
      this.data_id = 1
      this.data_list = []
      this.data_edit_list = []
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/promotion/promodetail/'+this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.promo = {
            promotion_title: res.data.detail.promoDetail.promotion_title,
            promotion_price: res.data.detail.promoDetail.promotion_price.toString(),
            promotion_code: res.data.detail.promoDetail.promotion_code,
            date_start: res.data.detail.promoDetail.date_start,
            date_stop: res.data.detail.promoDetail.date_stop,
             date_now: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            promotion_buy: res.data.detail.promoDetail.promotion_buy.toString(),
            promotion_detail: res.data.detail.promoDetail.promotion_detail,
            promotion_type: 1,
          }
          if (res.data.detail.product) {
            const num = res.data.detail.product.length
            for (let index = 0; index < num; index++) {
              this.data_list.push({
                id: this.data_id,
                product_id: res.data.detail.product[index].product_id,
                product_code: res.data.detail.product[index].product_code,
                product_name: res.data.detail.product[index].name,
                unit_id: res.data.detail.product[index].unit_id,
                productlists_store_id: res.data.detail.product[index].productlists_store_id,
                unit_name: res.data.detail.product[index].unit,
                price_standard: res.data.detail.product[index].price_standard,
              })
              this.data_edit_list.push({
                id: this.data_id,
                product_id: res.data.detail.product[index].product_id,
                product_code: res.data.detail.product[index].product_code,
                product_name: res.data.detail.product[index].name,
                unit_id: res.data.detail.product[index].unit_id,
                unit_name: res.data.detail.product[index].unit,
                price_standard: res.data.detail.product[index].price_standard,
                result_id: res.data.detail.product[index].id,
                is_delete: 0,
              })
              this.data_id += 1
            }
          }
          this.loading_page = false
        }
      })
    },
    async productList(){
      this.loading_page = true
      this.product_list = []
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/promotion/productlist', config).then((res) => {
        if (res.data.successful === true) {
          this.product_list = res.data.productlist
          this.loading_page = false
        }
      })
    },
    async getUnit(){
      this.product_unit_list = []
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/promotion/productunit/'+this.product_id, config).then((res) => {
        if (res.data.successful === true) {
          this.product_unit_list = res.data.product_unit
        }
      })
    },
    async selectProduct(){
      const product_detail = this.product_list.find((detail) => detail.id == this.product_id)
      const product_unit_detail = this.product_unit_list.find((detail) => detail.id == this.product_unit_id)
      const checkValue = this.data_list.find((detail) => detail.product_id == product_detail.id && detail.unit_id == product_unit_detail.id)
      if (!checkValue) {
        this.data_list.push({
          id: this.data_id,
          product_id: product_detail.id,
          product_code: product_detail.product_code,
          product_name: product_detail.name,
          unit_id: product_unit_detail.id,
          productlists_store_id: product_unit_detail.productlists_store_id,
          unit_name: product_unit_detail.name,
          price_standard: product_unit_detail.price_standard,
        })
        this.data_edit_list.push({
          id: this.data_id,
          product_id: product_detail.id,
          product_code: product_detail.product_code,
          product_name: product_detail.name,
          unit_id: product_unit_detail.id,
          productlists_store_id: product_unit_detail.productlists_store_id,
          unit_name: product_unit_detail.name,
          price_standard: product_unit_detail.price_standard,
          result_id: null,
          is_delete: 0,
        })
        this.data_id += 1
      }
      if (checkValue) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'มีสินค้านี้อยู่ในรายการที่เลือกแล้ว',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      }

      this.$nextTick(() => {
        this.product_id = ''
        this.product_unit_id = ''
        this.product_unit_list = []
      })
    },
    async deleteDataList(id){
      let checkValue = this.data_edit_list.find((detail) => detail.id == id)
      if (checkValue.is_delete == 0) {
        checkValue.is_delete = 1
      }
      if (!checkValue.result_id) {
        this.data_edit_list = this.data_edit_list.filter((detail) => detail.id != id)
      }
      this.data_list = this.data_list.filter((detail) => detail.id != id)
    },
    async editPromotionNew(){
      const num = this.data_edit_list.length
      if (num == 0) {
          Swal.fire({
            title: 'แจ้งเตือน',
            text: 'กรุณาเลือกสินค้าที่เข้าร่วมโปรโมชั่น อย่างน้อย 1 รายการ',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          });
          return
      }
      if (this.$refs.form.validate()) {
        this.loading_page = true
        let productList = []
        for (let index = 0; index < num; index++) {
          if (this.data_edit_list[index].is_delete == 1) {
            productList.push({
              product_code: this.data_edit_list[index].product_code,
              productlists_store_id: this.data_edit_list[index].productlists_store_id,
              id: this.data_edit_list[index].result_id,
              is_delete: this.data_edit_list[index].is_delete,
            })            
          }else{
            productList.push({
              product_code: this.data_edit_list[index].product_code,
              productlists_store_id: this.data_edit_list[index].productlists_store_id,
              id: this.data_edit_list[index].result_id,
            })
          }
        }
        const data = {
          promo: this.promo,
          product: productList
        }
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        await HTTP_ARIN.post('/promotion/editpromo/'+this.$route.params.id, data, config).then((res) => {
          if (res.data.successful === true) {
              this.loading_page = false
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'แก้ไขข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.href = '/arin/pos/promotionlist?tab=2';
                  });
                }
              })
          }
        })
      }
    },
  },
  created(){
    this.productList()
  },
  mounted(){
    this.promotionNewDetail()
  },
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.input-radius {
  border-radius: 10px;
}

.grid_four {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.mobile_btn {
  width: 15%;
}
</style>
